var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraggable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57792 2.94444C1.8971 2.94444 2.15584 2.62109 2.15584 2.22222C2.15584 1.82335 1.8971 1.5 1.57792 1.5C1.25874 1.5 1 1.82335 1 2.22222C1 2.62109 1.25874 2.94444 1.57792 2.94444Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20134 2.94444C6.52051 2.94444 6.77926 2.62109 6.77926 2.22222C6.77926 1.82335 6.52051 1.5 6.20134 1.5C5.88216 1.5 5.62341 1.82335 5.62341 2.22222C5.62341 2.62109 5.88216 2.94444 6.20134 2.94444Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57792 8.72179C1.8971 8.72179 2.15584 8.39844 2.15584 7.99957C2.15584 7.60069 1.8971 7.27734 1.57792 7.27734C1.25874 7.27734 1 7.60069 1 7.99957C1 8.39844 1.25874 8.72179 1.57792 8.72179Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20134 8.72179C6.52051 8.72179 6.77926 8.39844 6.77926 7.99957C6.77926 7.60069 6.52051 7.27734 6.20134 7.27734C5.88216 7.27734 5.62341 7.60069 5.62341 7.99957C5.62341 8.39844 5.88216 8.72179 6.20134 8.72179Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57792 14.4991C1.8971 14.4991 2.15584 14.1758 2.15584 13.7769C2.15584 13.378 1.8971 13.0547 1.57792 13.0547C1.25874 13.0547 1 13.378 1 13.7769C1 14.1758 1.25874 14.4991 1.57792 14.4991Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20134 14.4991C6.52051 14.4991 6.77926 14.1758 6.77926 13.7769C6.77926 13.378 6.52051 13.0547 6.20134 13.0547C5.88216 13.0547 5.62341 13.378 5.62341 13.7769C5.62341 14.1758 5.88216 14.4991 6.20134 14.4991Z",
    fill: "#727782",
    stroke: "#727782",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.59366dafe950ae8b3ec2ef2f5f6d9da7.svg";
export { ForwardRef as ReactComponent };